import {Component, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-maintenance-page',
  templateUrl: './maintenance-page.component.html',
  styleUrls: ['./maintenance-page.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MaintenancePageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
